// extracted by mini-css-extract-plugin
export default {"title":"_3ca39adce3","bld":"_810c0a15e4"};